import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Logonsite from './pages/Logonsite';
import Logon from './pages/Logon';
import Register from './pages/Register';
import Timeline from './pages/Timeline';
import Perfil from './pages/Perfil';
import Ranking from './pages/Ranking';
import Escalas from './pages/Escalas';
import Negociacoes from './pages/Negociacoes';
import Classificados from './pages/Classifieds';
import Publicacoes from './pages/Publicacoes';
import TimelineDetalhe from './pages/TimelineDetalhe';
import Meusanuncios from './pages/Meusanuncios';
import Mensagem from './pages/Mensagem';
import Negocio from './pages/Negocio';
import NegocioDetalhe from './pages/NegocioDetalhe';
import Recuperar from './pages/Recuperar';
import Anuncio from './pages/Anuncio';
import EscalasDetalhe from './pages/EscalasDetalhe';
import SemPermissao from './pages/SemPermissao';
import RankingDetalhe from './pages/RankingDetalhe';
import PerfilEdit from './pages/PerfilEdit';
import PerfilInteresses from './pages/PerfilInteresses';
import Sobre from './pages/Sobre';
import NegocioInformacao from './pages/NegocioInformacao';
import MeusanunciosAlterar from './pages/MeusanunciosAlterar';
import MeusanunciosDetalhe from './pages/AnuncioDetalhe';
import PublicacaoAlterar from './pages/PublicacaoAlterar';
import PerfilEditSenha from './pages/PerfilEditSenha';
import TimelineBusca from './pages/TimelineBusca';
import Notificacoes from './pages/Notificacoes';
import Termos from './pages/Termos';
import PlanList from './pages/PlansList/listaPlanos';
import PaymentMethod from './pages/PaymentMethod/paymentmethod';
import DadosPagamento from './pages/DadosPagamento/DadosPagamento';
import PagamentoCartao from './pages/PagamentoCartao/PagamentoCartao';
import PagamentoBoleto from './pages/PagamentoBoleto/PagamentoBoleto';
import Obrigado from './pages/Obrigado/Obrigado';
import CancelPlan from './pages/CancelPlan/CancelPlan';
export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Logon} />
        <Route path="/login" exact component={Logonsite} />
        <Route path="/register" exact component={Register} />
        <Route path="/timeline" exact component={Timeline} />
        <Route path="/timeline/:page" component={Timeline} />
        <Route path="/perfil" component={Perfil} />
        <Route path="/ranking" component={Ranking} />
        <Route path="/escalas" exact component={Escalas} />
        <Route path="/negociacoes" exact component={Negociacoes} />
        <Route path="/classificados" component={Classificados} />
        <Route path="/publicacoes" component={Publicacoes} />
        <Route path="/post/:id" component={TimelineDetalhe} />
        <Route path='/meus-anuncios' exact component={Meusanuncios} />
        <Route path='/mensagem' component={Mensagem} />
        <Route path='/negocio/cadastrar' component={Negocio} />
        <Route path='/negocio/alterar/:id' component={NegocioDetalhe} />
        <Route path='/recuperar' exact component={Recuperar} />
        <Route path='/anuncio' component={Anuncio} />
        <Route path='/escala/:id' component={EscalasDetalhe} />
        <Route path='/sempermissao' component={SemPermissao} />
        <Route path='/rankingdetalhe/:id' component={RankingDetalhe} />
        <Route path='/user/edit' component={PerfilEdit} />
        <Route path='/user/interesses' component={PerfilInteresses} />
        <Route path='/sobre' component={Sobre} />
        <Route path='/negocio/informacao/:id' component={NegocioInformacao} />
        <Route path='/meus-anuncios/alterar/:id' component={MeusanunciosAlterar} />
        <Route path='/meus-anuncios/detalhe/:id' component={MeusanunciosDetalhe} />
        <Route path='/publicacao/alterar/:id' component={PublicacaoAlterar} />
        <Route path='/user/alterar/senha' component={PerfilEditSenha} />
        <Route path='/timelinebusca' component={TimelineBusca} />
        <Route path='/notificacoes' component={Notificacoes} />  
        <Route path='/termos' component={Termos} />
        <Route path='/checkout/plano' exact component={PlanList} /> 
        <Route path='/checkout/metodo-pagamento'exact component={PaymentMethod} /> 
        <Route path='/checkout/endereço' exact component={DadosPagamento } /> 
        <Route path='/checkout/pagamento-cartao' exact component={PagamentoCartao} /> 
        <Route path='/checkout/obrigado-boleto'exact  component={PagamentoBoleto} /> 
        <Route path='/checkout/obrigado-cartao'exact  component={Obrigado} />
        <Route path='/cancel-plan'exact  component={CancelPlan} />        
      </Switch>
    </BrowserRouter>
  );
}